import { useTranslations } from "next-intl";

import { getLinktivityPricingCategoryKey } from "~/lib/linktivity";

export function LinktivityPricingCategoryLabel({
  type: categoryType,
}: {
  type: string;
}) {
  const t = useTranslations("TourDetails");
  const key = getLinktivityPricingCategoryKey(categoryType);
  return key ? t(key) : categoryType;
}
